import { useEffect, useState } from "react";
import { Button, Card, Col, Form, InputGroup, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import APICallService from "../../../../api/apiCallService";
import { VENDORS } from "../../../../api/apiEndPoints";
import Loader from "../../../../Global/loader";
import { vendorJSON } from "../../../../api/apiJSON/vendor";
import { success } from "../../../../Global/toast";
import { VendorToast } from "../../../../utils/toast";
const PAGE_SIZE = 10;
const AllServices = (props: any) => {
  const navigate = useNavigate();
  const [showAllImages, setShowAllImages] = useState<any>({});
  const [serviceList, setServiceList] = useState<any>();
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [expandedIndexes, setExpandedIndexes] = useState([]);
  useEffect(() => {
    const lastpage = Math.ceil(total / PAGE_SIZE);
    if (page <= lastpage || total === 0) {
      fetchAllServices();
    }
  }, [page]);

  const fetchAllServices = async () => {
    setLoading(true);
    const apiService = new APICallService(
      VENDORS.getAllServices,
      {
        pageNo: page,
        limit: PAGE_SIZE,
        needCount: true,
        sortKey: "_createdAt",
        sortOrder: -1,
      },
      { _id: props?.serviceDetails?._id }
    );
    const response = await apiService.callAPI();
    if (response) {
      setTotal(response.total);
      setServiceList((prevList: any) =>
        prevList ? [...prevList, ...response.records] : [...response.records]
      );
      setLoading(false);
    }
  };

  const handleScroll = () => {
    if (
      window.innerHeight + window.scrollY >=
      document.documentElement.scrollHeight
    ) {
      // setPage((prevPage) => prevPage + 1);
      setPage(page + 1);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const handleReadMore = (index: any) => {
    setExpandedIndexes((prevState) => {
      const newExpandedIndexes: any = [...prevState];
      newExpandedIndexes[index] = !newExpandedIndexes[index];
      return newExpandedIndexes;
    });
  };
  const handleShowAllImages = (index: any) => {
    setShowAllImages((prevState: any) => ({ ...prevState, [index]: true }));
  };
  const handleCheckboxChange = async (
    event: any,
    services: any,
    index: number
  ) => {
    const isChecked = event.target.checked;
    let apiService = new APICallService(
      VENDORS.updateServiceStatus,
      vendorJSON.updateServiceStatus(isChecked),
      { id: services._id }
    );
    let response = await apiService.callAPI();
    if (response) {
      const temp = [...serviceList];
      temp[index].isApproved = isChecked;
      setServiceList(temp);
      isChecked
        ? success(VendorToast.activate)
        : success(VendorToast.deactivate);
    }
  };

  return (
    <>
      <Row className="gy-6">
        {serviceList?.length
          ? serviceList?.map((service: any, index: number) => (
              <Col md={6} className="mb-4 d-flex" key={index}>
                <Card className="bg-light border w-100">
                  <Card.Body className="p-7">
                    <Row className="align-items-center mb-4">
                      <Col>
                        <h2 className="fs-18 fw-bolder mb-0">
                          {service?.serviceName}
                        </h2>
                      </Col>
                      <Col xs="auto">
                        <div className="d-flex justify-content-end">
                          <label className="form-check form-switch form-check-custom form-check-solid ">
                            <input
                              className="form-check-input form-check-success w-50px h-30px "
                              type="checkbox"
                              name="notifications"
                              checked={service?.isApproved}
                              onChange={(event) =>
                                handleCheckboxChange(event, service, index)
                              }
                            />
                          </label>
                        </div>
                      </Col>
                    </Row>
                    <p className="fs-15 fw-500">
                      {service?.description?.length > 140
                        ? expandedIndexes[index]
                          ? service?.description
                          : `${service?.description?.slice(0, 120)}.......`
                        : service?.description}
                      {service?.description?.length > 140 &&
                        !expandedIndexes[index] && (
                          <span
                            className="read-more"
                            onClick={() => handleReadMore(index)}
                          >
                            Read more
                          </span>
                        )}
                    </p>
                    <Row className="mb-5">
                      <Col md={1} xs={12} className="mb-2 mb-md-0">
                        <label className="fs-14 fw-bolder">Tags:</label>
                      </Col>
                      <Col md={11} xs={12}>
                        {service?.tags.map((tag: any, tagIndex: number) => (
                          <span key={tagIndex} className="fs-15 fw-500">
                            {tag.name}
                            {tagIndex !== service.tags.length - 1 && " , "}
                          </span>
                        ))}
                      </Col>
                    </Row>

                    <Row className="gy-4 gx-4">
                      {service?.attachments
                        .slice(
                          0,
                          showAllImages[index] ? service.attachments.length : 3
                        )
                        .map((image: any, imageIndex: any) => (
                          <Col xs="auto" className="service-image">
                            <img
                              key={imageIndex}
                              src={image.url}
                              alt={`Service ${index} image ${imageIndex}`}
                              className="img-fluid mb-2"
                            />
                          </Col>
                        ))}
                      {!showAllImages[index] && service.attachments.length > 3 && (
                        <Col xs="auto">
                          <Button
                            className="more-images"
                            onClick={() => handleShowAllImages(index)}
                          >
                            +{service.attachments.length - 3} more
                          </Button>
                        </Col>
                      )}
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            ))
          : !loading && <h3 className="text-center">No data Found</h3>}
        {loading && (
          <div className="d-flex justify-content-center">
            <Loader loading={loading} />
          </div>
        )}
      </Row>
    </>
  );
};
export default AllServices;
